module.exports = __webpack_public_path__ + "img/GDImg.6495c80a.png";